import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../components/menu/products/productsSlice";
import { fetchSettings } from "../../components/navigation/header/headerSlice";
import { fetchCategories } from "../../components/menu/categories/categoriesSlice";
import { ReactComponent as CocktailIcon } from '../../assets/images/icons/cocktail.svg';
import { LoadingDots } from "../../components/template/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { setTable } from "../../components/cart/cartSlice";
import { changeFirstFetch, fetchOrders, selectAll as ordersSelector } from "../../components/orders/ordersSlice";

export const PreLoader = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const param = searchParams.get('tb');console.log(param);
    const table = useSelector(state => state.cart.tableId);
    const productsLoadingStatus = useSelector(state => state.products.productsLoadingStatus);
    const headerLoadingStatus = useSelector(state => state.header.headerLoadingStatus);
    const categoriesLoadingStatus = useSelector(state => state.categories.categoriesLoadingStatus);
    const ordersLoadingStatus = useSelector(state => state.orders.ordersLoadingStatus);
    const orders = useSelector(state => state.orders.count);
    const ordersFirstFetch = useSelector(state => state.orders.firstFetch);

    useEffect(() => {
        dispatch(fetchProducts());
        dispatch(fetchSettings());
        dispatch(fetchCategories());
        if (param) {console.log(param);
            dispatch(fetchOrders({table: param}));
            dispatch(setTable(param));
            dispatch(changeFirstFetch(false));
        }
        
    }, []);

    

    useEffect(() => {
        if (!param && !table) {
            const error = new Error('Cтіл не знайдено');
            error.status = 'no table id';
            throw error;
        }
    }, [param, table]);

    useEffect(() => {
        if (orders !== 0) {
            navigate('/orders');
        }
    }, [navigate, orders]);

    if (
        productsLoadingStatus !== 'idle' || 
        headerLoadingStatus !== 'idle' || 
        categoriesLoadingStatus !== 'idle' ||
        (ordersLoadingStatus !== 'idle' && ordersFirstFetch)
    ) {
        return (
            <div className="container-fluid text-center d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="row align-items-center">
                    <div className="col-12 align-self-center mb-5"><CocktailIcon /></div>
                    <div className="col-12 align-self-center fw-bold fs-5"><LoadingDots /></div>
                </div>
            </div>
        );
    }

    return children;
};
